import { Grid, Skeleton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { CommissionDto, CommissionsFormDto, SearchCommissionsDto } from '../../../services/dtos/commission.dto';
import { showAxiosMessageError } from '../../../utils/error-message.util';
import { searchCommissionsFromService } from '../../../services/commissions.service';
import CardCommission from '../../commun/card-commission';
import ListMembersCommissionDialogUi from './list-members-commission.dialog.ui';
import CommissionsForm from '../../forms/commissions/commissions.form';

/**
 * Ui de l'onglet composition
 * @constructor
 */
export default function CommissionsUi(
    props: Readonly<{ handlerCommissionShowMeetings: (commission: CommissionDto) => void }>
) {
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    //Searching
    const [searching, setSearching] = useState<boolean>(false);
    //Ouverture de la popup liste des membres
    const [open, setOpen] = useState<boolean>(false);
    //Ouverture de la popup liste des membres
    const [commissionSelected, setCommissionSelected] = useState<CommissionDto>();
    //Critères de recherche onglet decisions et deliberations
    const [searchCommissions, setSearchCommissions] = useState<SearchCommissionsDto>({
        paramTitle: '',
        paramDate: '',
        paramMember: '',
    });
    // result tableau decisions
    const [commissions, setCommissions] = useState<Array<CommissionDto>>();

    //Lancement de la recherche a chaque changement
    useEffect(() => {
        let isMounted = true;

        setSearching(true);
        searchCommissionsFromService(searchCommissions)
            .then(result => {
                if (isMounted) {
                    setCommissions(result);
                }
            })
            .catch(error => {
                if (!isMounted) {
                    return;
                }

                console.error('Erreur lors de la récupération des données');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                if (isMounted) {
                    setSearching(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [searchCommissions, showMessage]);

    // Ouverture de la liste des membres de la commissions
    const handleShowListMembers = (commission: CommissionDto) => {
        setOpen(true);
        setCommissionSelected(commission);
    };

    // Fermenture de la liste des membres de la commissions
    const handleCloseListMembers = () => {
        setOpen(false);
    };

    // Mise en place du formulaire à renvoyer côté back pour les commissions
    const handlerSearch = (paramForm: CommissionsFormDto) => {
        if (searchCommissions) {
            const newSearchData: SearchCommissionsDto = {
                paramTitle: paramForm.title,
                paramDate: paramForm.date,
                paramMember: paramForm.member,
            };
            setSearchCommissions(newSearchData);
        }
    };

    //Retourne la vue
    return (
        <Grid container className={'tab-content commissions-ui'} rowSpacing={2} columnSpacing={7}>
            <Grid item xs={12}>
                <Typography variant="h3" className={'title'}>
                    <CalendarMonthIcon /> Commissions
                </Typography>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
                <CommissionsForm handlerSearch={handlerSearch} searching={searching} />
            </Grid>
            <Grid item xs={1}></Grid>
            {searching && (
                <Grid item xs={12} md={12}>
                    <Skeleton variant="rectangular" height={250}></Skeleton>
                </Grid>
            )}
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
                <Grid container rowSpacing={2} columnSpacing={5}>
                    {!searching &&
                        commissions?.map(commission => (
                            <Grid item xs={12} md={6} key={commission.title}>
                                <CardCommission
                                    commission={commission}
                                    handleShowListMembers={handleShowListMembers}
                                    handleShowMeetings={props.handlerCommissionShowMeetings}
                                />
                            </Grid>
                        ))}
                </Grid>
            </Grid>
            <Grid item xs={1}></Grid>
            <ListMembersCommissionDialogUi
                open={open}
                members={commissionSelected?.members}
                handleClose={handleCloseListMembers}
            />
        </Grid>
    );
}
